export function sortArray<T>(data: T[], sortColumn: keyof T, sortDirection: 'asc' | 'desc' = 'asc'): T[] {
  const direction = sortDirection === 'asc' ? 1 : -1
  return [...data].sort((a, b) => {
    const aValue = a[sortColumn]
    const bValue = b[sortColumn]

    if (typeof aValue === 'string' || typeof bValue === 'string') {
      const aText = String(aValue ?? '')
      const bText = String(bValue ?? '')
      return aText.localeCompare(bText) * direction
    }

    const aNumber = Number(aValue ?? 0)
    const bNumber = Number(bValue ?? 0)
    return (aNumber - bNumber) * direction
  })
}

export function isEmptyObject(obj: object) {
  return obj === null || Object.keys(obj).length === 0
}

export function isPlainObject(value: unknown): value is Record<string, unknown> {
  if (value === null || typeof value !== 'object') {
    return false
  }
  const proto = Object.getPrototypeOf(value)
  return proto === Object.prototype || proto === null
}

function camelToSnake(value: string): string {
  return value
    .replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, '$1_$2')
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .toLowerCase()
}

export function convertKeysCamelToSnake<T>(value: T): T {
  if (Array.isArray(value)) {
    return value.map(item => convertKeysCamelToSnake(item)) as T
  }
  if (!isPlainObject(value)) {
    return value
  }

  const result: Record<string, unknown> = {}
  Object.entries(value).forEach(([key, item]) => {
    result[camelToSnake(key)] = convertKeysCamelToSnake(item)
  })

  return result as T
}

export function maskEmail(email: string) {
  const [name, domain] = email.split('@')
  return `${maskName(name)}@${domain}`
}

export function maskName(name: string) {
  return name.slice(0, 1) + '***' + name.slice(-1)
}
